'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _reactRedux = require('react-redux');

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _WMCircularProgress = require('@workmarket/front-end-components/dist/WMCircularProgress');

var _WMCircularProgress2 = _interopRequireDefault(_WMCircularProgress);

var _WMHeading = require('@workmarket/front-end-components/dist/WMHeading');

var _WMHeading2 = _interopRequireDefault(_WMHeading);

var _WMMessageBanner = require('@workmarket/front-end-components/dist/WMMessageBanner');

var _WMMessageBanner2 = _interopRequireDefault(_WMMessageBanner);

var _connect = require('../../connect');

var _WMCompanyPageOverview = require('../WMCompanyPageOverview');

var _WMCompanyPageOverview2 = _interopRequireDefault(_WMCompanyPageOverview);

var _WMCompanyPageTalentPools = require('../WMCompanyPageTalentPools');

var _WMCompanyPageTalentPools2 = _interopRequireDefault(_WMCompanyPageTalentPools);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WMCompanyPage = function (_Component) {
	_inherits(WMCompanyPage, _Component);

	function WMCompanyPage() {
		_classCallCheck(this, WMCompanyPage);

		return _possibleConstructorReturn(this, (WMCompanyPage.__proto__ || Object.getPrototypeOf(WMCompanyPage)).apply(this, arguments));
	}

	_createClass(WMCompanyPage, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _props = this.props,
			    companyNumber = _props.companyNumber,
			    fetchCompanyInfo = _props.fetchCompanyInfo,
			    csrf = _props.csrf,
			    isPublic = _props.isPublic;

			fetchCompanyInfo(companyNumber, isPublic, csrf);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props2 = this.props,
			    companyInfoReceived = _props2.companyInfoReceived,
			    compact = _props2.compact,
			    companyNumber = _props2.companyNumber,
			    csrf = _props2.csrf,
			    isPublic = _props2.isPublic,
			    companyProfile = _props2.companyProfile;


			var blockProfileError = companyProfile.get('blockCompanyRequestError');
			return _react2.default.createElement(
				'div',
				{
					style: _styles2.default.body
				},
				companyInfoReceived ? _react2.default.createElement(
					'div',
					null,
					blockProfileError && _react2.default.createElement(
						_WMMessageBanner2.default,
						{
							status: 'error'
						},
						blockProfileError
					),
					_react2.default.createElement(_WMCompanyPageOverview2.default, {
						companyNumber: companyNumber,
						csrf: csrf,
						isPublic: isPublic
					}),
					!compact && _react2.default.createElement(_WMCompanyPageTalentPools2.default, null)
				) : _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_WMHeading2.default,
						{
							level: '1',
							style: _styles2.default.pageTitle(true)
						},
						'Loading Company Profile...'
					),
					_react2.default.createElement(_WMCircularProgress2.default, {
						mode: 'indeterminate',
						style: _styles2.default.loader
					})
				)
			);
		}
	}]);

	return WMCompanyPage;
}(_react.Component);

var _default = (0, _reactRedux.connect)(_connect.mapStateToProps, _connect.mapDispatchToProps)((0, _radium2.default)(WMCompanyPage));

exports.default = _default;


WMCompanyPage.propTypes = {
	companyNumber: _propTypes.PropTypes.string.isRequired,
	fetchCompanyInfo: _propTypes.PropTypes.func.isRequired,
	csrf: _propTypes.PropTypes.string.isRequired,
	companyInfoReceived: _propTypes.PropTypes.bool.isRequired,
	compact: _propTypes.PropTypes.bool,
	isPublic: _propTypes.PropTypes.bool,
	companyProfile: _propTypes.PropTypes.objectOf(_propTypes.PropTypes.any)
};

WMCompanyPage.defaultProps = {
	isPublic: false,
	compact: false,
	companyProfile: {}
};
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(WMCompanyPage, 'WMCompanyPage', 'src/components/WMCompanyPage/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMCompanyPage/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/components/WMCompanyPage/index.js
// module id = YksE
// module chunks = 62 63